import React from 'react';
import ArrowIcon from '../Icons/ArrowIcon';

const BackButton = ({ onClick , isDisabled = false }) => {



  return (
    <button
      disabled={isDisabled}
      onClick={isDisabled ? undefined : onClick}
      aria-label="Back"

      style={{
        width: 70,
        height: 50,
        borderRadius: 8,
        border: '1px solid var(--primary)',
        background: '#fff',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        boxSizing: 'border-box',
        padding: 0,
        opacity: isDisabled ? 0.5 : 1,
        cursor: isDisabled ? 'not-allowed' : 'pointer',
      }}
    >
  <ArrowIcon size={18} color={'#7876A1'} />
    </button>
  );
};

export default BackButton;
